//
//
//
//
//

export default {
  name: 'search_shop'
};